module.exports = __webpack_public_path__ + "static/media/tripadvisor-light.e501f1c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/tripadvisor-light.svg
// module id = 435
// module chunks = 0